module.exports = __webpack_public_path__ + "img/6ee6fc7.jpg";